import { useChannelTasksStore } from '../../../store/tasks';

export const useTasks = (channelId: string) => {
  const activeTask = useChannelTasksStore((s) => s.channelTasks[channelId]);

  return {
    active: activeTask,
  };
};
